import { parse } from 'papaparse';

document.addEventListener('DOMContentLoaded', function () {

    const target = document.querySelector('.csv');

    const sortTextArea = async () => {
        const csvData = document.querySelector('.csv').getAttribute('data-csv');
        try {
            let list = [];
            parse(csvData, {
                download: false,
                // delimiter: ',',
                complete: function (results) {
                    let data = results?.data;
                    for (const d of data) {
                        let li = `<li>${d}</li>`;
                        list.push(li);
                    };
                    target.innerHTML = `
                        <ul id="alph-list">
                            ${list.sort().join('')}
                        </ul>
                        `;
                    return list;
                }
            });
        } catch (err) {
            console.error(err);
            target.innerHTML = `<p class="error">There was a problem loading this section. Please try again later...</p>`;
        };
    };

    if (target) sortTextArea();


});